// src/store/electronOneWaySyncPlugin.js

/**
 * 创建一个单向同步的 Vuex 插件
 * @param {object} options
 * @param {boolean} options.isMaster - 是否为主控窗口 (A窗口)
 */
export default function createOneWaySyncPlugin({ isMaster = false } = {}) {
    return (store) => {
        if (isMaster) {
            // ===== 主控窗口 (A) 的逻辑 =====
            // 主控窗口不需要监听外部状态，它只是状态的源头。
            // 我们在它初始化后，立即推送一次状态，以确保主进程有初始值。
            const initialState = JSON.parse(JSON.stringify(store.state));
            window.electronAPI.send('push-state-to-windows', initialState);
            return;
        }

        // ===== 从属窗口 (B) 的逻辑 =====

        // 1. 初始化时，向主进程请求最新的状态
        window.electronAPI.invoke('get-initial-state').then(state => {
            if (state && Object.keys(state).length > 0) {
                // replaceState 会用新状态完全替换当前 store 的状态
                store.replaceState(state);
            }
        });

        // 2. 监听主进程推送过来的新状态
        window.electronAPI.on('apply-state', (partialState) => {
            // 直接替换本地 store 的状态
            // store.replaceState(state);
            console.log("副窗口收到同步消息，准备同步")
            store.commit('UPDATE_PARTIAL_STATE', partialState);
        });
    };
}